import { gregorianToBuddhist } from "../utils/formatters.js";

/**
 * Filter Panel Component
 * Liquid Glass styled filter controls
 */
export class FilterPanel {
  constructor() {
    this.onFilterChange = null;
  }

  setFilterCallback(callback) {
    this.onFilterChange = callback;
  }

  render(metadata = null) {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let i = 0; i <= 5; i++) {
      const year = currentYear - i;
      const buddhistYear = gregorianToBuddhist(year);
      yearOptions.push(`<option value="${year}">${buddhistYear}</option>`);
    }

    const laoMonths = [
      "ມັງກອນ",
      "ກຸມພາ",
      "ມີນາ",
      "ເມສາ",
      "ພຶດສະພາ",
      "ມິຖຸນາ",
      "ກໍລະກົດ",
      "ສີງຫາ",
      "ກັນຍາ",
      "ຕຸລາ",
      "ພະຈິກ",
      "ທັນວາ",
    ];
    const monthOptions = laoMonths
      .map((month, index) => `<option value="${index + 1}">${month}</option>`)
      .join("");

    const projectOptions = metadata?.projects
      ? metadata.projects
          .map((p) => `<option value="${p}">${p}</option>`)
          .join("")
      : "";

    const accountTypeOptions = metadata?.accountTypes
      ? metadata.accountTypes
          .map((a) => `<option value="${a}">${a}</option>`)
          .join("")
      : "";

    return `
      <div class="glass-panel">
        <div class="filter-header">
          <h2 class="section-title">
            🔍 <span class="filter-title-text">ກອງຂໍ້ມູນລາຍງານ</span>
          </h2>
          <div class="filter-actions-top">
            <button id="clearFiltersBtn" class="btn btn-secondary btn-sm">🔄 ລ້າງ</button>
            <button id="applyFiltersBtn" class="btn btn-primary btn-sm">⚡️ ກອງ</button>
          </div>
        </div>

        <div class="filter-grid-4">
          <div class="form-group">
            <label for="filterYear">🗓️ ປີ</label>
            <select id="filterYear">
              <option value="">ທຸກປີ</option>
              ${yearOptions.join("")}
            </select>
          </div>
          
          <div class="form-group">
            <label for="filterMonth">📅 ເດືອນ</label>
            <select id="filterMonth">
              <option value="">ທຸກເດືອນ</option>
              ${monthOptions}
            </select>
          </div>
          
          <div class="form-group">
            <label for="filterProject">🏗️ ໂຄງການ</label>
            <select id="filterProject">
              <option value="">ທຸກໂຄງການ</option>
              ${projectOptions}
            </select>
          </div>
          
          <div class="form-group">
            <label for="filterAccountType">💳 ປະເພດບັນຊີ</label>
            <select id="filterAccountType">
              <option value="">ທຸກປະເພດ</option>
              ${accountTypeOptions}
            </select>
          </div>
        </div>
      </div>
    `;
  }

  initialize() {
    const applyBtn = document.getElementById("applyFiltersBtn");
    const clearBtn = document.getElementById("clearFiltersBtn");

    if (applyBtn) {
      applyBtn.addEventListener("click", () => this.handleApply());
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", () => this.handleClear());
    }

    const selects = document.querySelectorAll(
      "#filterYear, #filterMonth, #filterProject, #filterAccountType",
    );
    selects.forEach((select) => {
      select.addEventListener("change", () => this.handleApply());
    });
  }

  /**
   * Set the filter panel into loading state (disable controls, show spinner on button)
   */
  setLoading(isLoading) {
    const applyBtn = document.getElementById("applyFiltersBtn");
    const clearBtn = document.getElementById("clearFiltersBtn");
    const selects = document.querySelectorAll(
      "#filterYear, #filterMonth, #filterProject, #filterAccountType",
    );

    if (isLoading) {
      if (applyBtn) {
        applyBtn.disabled = true;
        applyBtn.innerHTML = `
          <span style="display:inline-flex; align-items:center; gap:0.4rem;">
            <span style="width:14px; height:14px; border:2px solid rgba(255,255,255,0.4); border-top-color:#fff; border-radius:50%; display:inline-block; animation:spinLoader 0.7s linear infinite;"></span>
            ກຳລັງໂຫຼດ...
          </span>`;
      }
      if (clearBtn) clearBtn.disabled = true;
      selects.forEach((s) => (s.disabled = true));
    } else {
      if (applyBtn) {
        applyBtn.disabled = false;
        applyBtn.innerHTML = "⚡️ ກອງ";
      }
      if (clearBtn) clearBtn.disabled = false;
      selects.forEach((s) => (s.disabled = false));
    }
  }

  handleApply() {
    if (this.onFilterChange) {
      const filters = {
        year: document.getElementById("filterYear")?.value || "",
        month: document.getElementById("filterMonth")?.value || "",
        project: document.getElementById("filterProject")?.value || "",
        accountType: document.getElementById("filterAccountType")?.value || "",
      };
      this.onFilterChange(filters);
    }
  }

  handleClear() {
    const selects = document.querySelectorAll(
      "#filterYear, #filterMonth, #filterProject, #filterAccountType",
    );
    selects.forEach((select) => {
      select.value = "";
    });
    this.handleApply();
  }
}
